import {
  AddressBasedTemplateDetailPage,
  type AddressBasedTemplatePageConfig,
} from "../check-arguments-templates-shared";

const config: AddressBasedTemplatePageConfig = {
  apiPathPrefix: "directorship",
  settingsPathPrefix: "directorship-templates",
  templateLabel: (t) => t("Directorship"),
  testIdPrefix: "directorship-template",
};

export function DirectorshipTemplateDetailPage() {
  return <AddressBasedTemplateDetailPage config={config} />;
}
